import React, { Component } from 'react';

class DateTime extends Component {
  render() {
    const { value } = this.props;
    let result = '';
    if (value && value.toLocaleString) {
      result = value.toLocaleString('nl-NL');
    }

    return (
      <span>
        {result}
      </span>
    );
  }
}

export default DateTime;



// WEBPACK FOOTER //
// ./src/shared/DateTime.js